module.exports = __webpack_public_path__ + "img/fish-tikkas.3eaabcce.jpg";